import React, {PureComponent} from 'react';

// 获取formcore上下文的HOC
const withCtxRef = (Plugin) => {
  return class extends PureComponent {
    render () {
      const props = {...this.props};
      return <Plugin {...props} />
    }
  }
}

export default withCtxRef;


// WEBPACK FOOTER //
// ./src/AntD/hoc/withCtxRef.js